/**
 * Semantic chart palettes for the web frontend (light surface).
 *
 * The agent picks a palette by intent (warm, cool, etc.) via the `send_chart`
 * MCP tool; the renderer maps it to surface-appropriate colors.
 */
import { CHART_COLORS } from './colors.js';

export type ChartPalette = 'default' | 'warm' | 'cool' | 'monochrome';

const WARM_COLORS = ['#ef4444', '#f97316', '#f59e0b', '#eab308', '#dc2626', '#e11d48'];
const COOL_COLORS = ['#06b6d4', '#3b82f6', '#8b5cf6', '#14b8a6', '#6366f1', '#22d3ee'];
const MONO_COLORS = ['#8b5cf6', '#7c3aed', '#a78bfa', '#6d28d9', '#c4b5fd', '#5b21b6'];

const palettes: Record<ChartPalette, string[]> = {
  default: CHART_COLORS,
  warm: WARM_COLORS,
  cool: COOL_COLORS,
  monochrome: MONO_COLORS,
};

export function getPalette(name: string | undefined): string[] {
  const key = name ?? 'default';
  if (key in palettes) return palettes[key as ChartPalette];
  return CHART_COLORS;
}
